var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.556 3a8.5 8.5 0 0 1-2.443 1.19A3.485 3.485 0 0 0 10 6.523v.778a8.29 8.29 0 0 1-7-3.523s-3.111 7 3.889 10.11a9.05 9.05 0 0 1-5.445 1.556c7 3.89 15.556 0 15.556-8.944q-.001-.326-.062-.646A6 6 0 0 0 18.555 3"
  })));
};
export default SvgTwitter;